import React from 'react';
import Lottie from 'lottie-react';
import checkmarkAnimation from '../../assets/lottie/confirm_lotties.json'; // percorso del tuo file

function ConfirmAnimation() {
    return (
        <div style={{ width: 200, height: 200, margin: "auto" }}>
            <Lottie animationData={checkmarkAnimation} loop={false} />
        </div>
    );
}

export default ConfirmAnimation;
